import { useContext, useEffect, useRef, useState } from 'react';
import "./style.css"
import Cart from '../../components/CartPopUp/components/Cart'
import {
    CART_LIST_API,
    CHECK_PAYMENT_STATUS_API,
    CHECKOUT_API,
    CHECKOUT_GUEST_DETAIL_API,
    CREATE_BOOKING_API,
    EVENT_GUEST_DATA_REQUIREMENTS_API,
    FINAL_BOOKING_API,
    SUBMIT_RESERVATION_GUEST_DATA,
} from '../../APIs';
import { filterDataContext } from '../../App'
import GuestDetail from './components/GuestDetail'
import CheckoutBooking from './components/BookingButton'
import { Form, Formik } from 'formik'
import { GUEST_DATA_INITIAl_VALUE, guestDataValidationSchema } from '../../constants/FormikYup/Index'
import { useLocation, useNavigate } from 'react-router-dom'
import { CHECKOUTPAGE, CONFIRMBOOKING, PRE_CHECKOUTPAGE } from '../../constants/RoutingPath';
import { toast } from 'react-toastify'
import { displayRazorpay } from '../../utils/handlePay'
import CheckoutBreadcrumb from '../../components/checkoutBreadcrumb'
import { scrollToTop } from '../../utils/func'
import FullPageLoader from '../../components/Loader/FullPageLoader';
import TicketPageLoader from '../../components/Loader/TicketLoader';


const CheckoutPage = () => {
    const fieldRefs = useRef({});
    const scrolRefs = useRef()
    const { cartData, setCartData, checkoutReserVationId, setCheckoutReservationId, setBackupReserveData, setReserVationData, timeRemaining, setCartValidUntil, cartQuantity, setCartQuantity, preFilledData, setPreFilledData, profileData } = useContext(filterDataContext)
    const [guestDataRequirement, setGuestDataRequirement] = useState([])
    const [categorisedData, setCategorisedData] = useState([])
    const [isBooking, setIsBooking] = useState(false)
    const [eventIds, setEventIDS] = useState([])
    const [eventRequirements, setEventRequirements] = useState(null)
    const [openErrorEvent, setErrorEvent] = useState(null)
    const [preCheckoutDetails, setPreCheckoutDetails] = useState([])
    const [razorPaymentOrderId, setRazorPaymentId] = useState(null)
    const [paymentLoader, setPaymentLoader] = useState(false)
    const [allUniqueRequiredFields, setAllUniqueReuiredFields] = useState([])
    const [loadingMsg, setLoadingMsg] = useState("Processing Payment...")
    const location = useLocation()
    const navigate = useNavigate()
    const [pageLoader, setPageLoader] = useState(false)
    const [orderTotalValue, setOrderTotalValue] = useState("")

    const checkForCheckoutPage = location.pathname === "/checkout"
    // const isToShowSupplierShow = profileData?.supplier_show
    const isToShowSupplierShow = false

    useEffect(() => {
        if (razorPaymentOrderId?.razorpay_order_id) {
            handleCheckPaymentStatus(razorPaymentOrderId?.razorpay_order_id)
        }
    }, [razorPaymentOrderId])


    useEffect(() => {
        if (checkForCheckoutPage) {
            scrollToTop()
        }
    }, [checkForCheckoutPage])

    useEffect(() => {
        const requiredFields = ["first_name",
            "last_name",
            "passport_number",
            "country_of_residence",
            "date_of_birth",
            "contact_email"]
        const getUniqueFields = (tickets, requiredFields) => {
            const fieldSet = new Set(requiredFields);
            tickets.forEach(ticket => {
                ticket.guests.forEach(guest => {
                    Object.keys(guest).forEach(field => {
                        fieldSet.add(field);
                    });
                });
            });

            return Array.from(fieldSet);
        };
        if (guestDataRequirement) {
            const data = getUniqueFields(guestDataRequirement, requiredFields)
            if (data?.length > 0) {
                setAllUniqueReuiredFields(data)
            }
        }
    }, [guestDataRequirement])

    useEffect(() => {
        if (cartData) {
            groupedTickets(cartData)
        }
    }, [cartData])

    useEffect(() => {
        const fetchEventRequirements = async () => {
            if (eventIds.length === 0) return;
            try {
                const data = await Promise.all(
                    eventIds.map(async (item) => {
                        const eventData = await fetchEventRequireApi(item);
                        return { [item]: eventData };
                    })
                );
                setEventRequirements(data);
            } catch (error) {
                console.error("FETCH_EVENT_REQUIREMENTS_ERROR:", error);
            }
        };
        if (eventIds.length > 0) {
            fetchEventRequirements();
        }
    }, [eventIds])


    const transformGuestData = (guests) => {
        return guests?.map(({ lead_guest, activeGuest, ...rest }) => {
            const transformedGuest = { lead_guest, activeGuest };
            Object.keys(rest).forEach((key) => {
                transformedGuest[key] = {
                    error: null,
                    value: rest[key] || null,
                };
            });

            return transformedGuest;
        })?.filter((item) => item?.activeGuest === true);
    };

    const convertTempGuestInfoData = (data) => {

        const priceMarkup = data?.price_markup
        const markupPercentage = data?.markup_percentage

        const convertedData = data?.BookingData?.map((item) => {
            let data = [];

            item?.tickets?.forEach((guestData) => {
                if (guestData?.guestDetail) {
                    data.push({
                        quantity: guestData?.guestDetail?.quantity,
                        ticket_id: guestData?.guestDetail?.ticket_id,
                        price_markup: priceMarkup ?? 0,
                        markup_percentage: markupPercentage ?? "",
                        guests: transformGuestData(guestData?.guests)
                    });
                }
            });
            return data;
        });
        return convertedData?.[0]
    }


    useEffect(() => {
        if (checkoutReserVationId) {
            fetchCheckoutDetail(checkoutReserVationId);
            fetchCheckoutGuestDetails(checkoutReserVationId);
            fetchCartList();
        }
    }, [checkForCheckoutPage, checkoutReserVationId])

    const fetchCheckoutDetail = async (id) => {
        try {
            const response = await CHECKOUT_API(id)
            if (response && response?.status) {
                setPreCheckoutDetails(response?.data?.items)
            }
        } catch (error) {
            console.log(error, "CHECKOUT_API")
        }
    }

    const fetchCartList = async () => {
        setCartData([])
        setCartQuantity(0)
        setCartValidUntil("")
        setPageLoader(true)
        try {
            const response = await CART_LIST_API()
            if (response?.status) {
                setCartValidUntil(response?.data?.valid_until_Ind)
                setCartData(response?.data?.items)
                setCheckoutReservationId(response?.data?.reservation_id)
                setPreFilledData(JSON.parse(response?.data?.temp_guest_info))
                setCartQuantity(response?.data?.totalTicketQuantity)
            } else {
                if (response?.message === "No reservation found" || response?.message === "Reservation time is over") {
                    setReserVationData([])
                    setBackupReserveData([])
                }
            }
        } catch (error) {
            console.log(error, "CART_LIST")
        } finally {
            setPageLoader(false)
        }
    }

    const fetchEventRequireApi = async (id) => {
        try {
            const response = await EVENT_GUEST_DATA_REQUIREMENTS_API(id)
            if (response && response?.status) {
                return response?.data?.guest_data_requirements
            }
        } catch (error) {
            console.log(error, "EVENT_DATA_REQUIREMENTS")
        }
    }


    const groupedTickets = (data) => {
        let groupedCategories = {};
        let eventIdFromItems = []
        data?.forEach((item) => {
            const { event_event, event_id } = item;
            if (groupedCategories[event_event.event_name]) {
                groupedCategories[event_event.event_name].push(item);
            } else {
                groupedCategories[event_event.event_name] = [item];
                eventIdFromItems.push(event_id)
            }
        });
        setEventIDS(eventIdFromItems)
        setCategorisedData(groupedCategories);
    };



    const fetchCheckoutGuestDetails = async (reserveId) => {
        try {
            const response = await CHECKOUT_GUEST_DETAIL_API(reserveId)
            if (response && response?.status) {
                setGuestDataRequirement(response?.data?.items)
            } else {
                setGuestDataRequirement([])
            }
        } catch (error) {
            console.log(error, "CHECKOUT_GUEST_DETAIL")
        }
    }

    const handleFormSubmit = async (values) => {
        if (checkForCheckoutPage) {
            handleCheckoutBooking(values)
        } else {
            handlePreCheckout(values)
        }
    }



    const handleFinalBooking = async (id) => {
        try {
            setLoadingMsg(`Redirecting ...`)
            const response = await FINAL_BOOKING_API(id)
            if (response && response?.status) {
                toast.success(response?.message)
                navigate(`${CONFIRMBOOKING}/${id}`)
            } else {
                toast.error(response?.message)
            }

        } catch (error) {
            console.log(error)
        } finally {
            setPaymentLoader(false)
            setLoadingMsg("")
        }
    }

    const handleCheckPaymentStatus = async (id) => {
        setPaymentLoader(true)
        try {
            const response = await CHECK_PAYMENT_STATUS_API(id)
            if (response) {
                if (response?.message === "Payment Success" || response?.message === "Payment Failed") {
                    setLoadingMsg(`${response?.msg} ...`)
                    handleFinalBooking(response?.data?.trp_booking_id)
                }
                else {
                    handleCheckPaymentStatus(id)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleCheckoutBooking = async (values) => {
        try {
            const payload = {
                payment_refrence: "",
                booking_refrence: "",
                ticket_download_mail: "",
            }
            const response = await CREATE_BOOKING_API(checkoutReserVationId, payload)
            if (response && response?.status) {
                const bookingId = response?.data?.booking_id
                displayRazorpay({ booking_id: bookingId }, setRazorPaymentId)
                fetchCartList()
            } else {
                toast.error(response?.message)
            }
        } catch (error) {
            console.log(error, "CHECKOUT_BOOKING")
        }
    }

    const handlePreCheckout = async (values) => {
        try {
            const convertedPayload = values?.BookingData?.map((booking, index) => booking?.tickets?.map((ticket) => {
                return ({
                    quantity: ticket?.quantity,
                    guests: ticket?.guests?.filter((item) => item?.activeGuest === true),
                    ticket_id: ticket?.ticket_id
                })
            }))
            let payloadData = []
            convertedPayload?.map((events) => {
                return events?.map((ticket) => payloadData.push(ticket))
            })
            const payload = {
                items: payloadData,
                temp_guest_info: convertTempGuestInfoData(values)
            }

            const response = await SUBMIT_RESERVATION_GUEST_DATA(checkoutReserVationId, payload)
            if (response && response?.status) {
                if (!checkForCheckoutPage) {
                    navigate(CHECKOUTPAGE)
                }
            } else {
                toast.error(response?.message)
            }
        } catch (error) {
            console.log(error, "SUBMIT_RESERVATION_DATA")

        }
    }

    const getGuestKeys = (data) => {
        let guestKeys = [];
        let errorEventIndex = null;
        if (!data) return
        if (data.hasOwnProperty("ticket_mail")) {
            return ["ticket_mail"]
        }
        data?.BookingData?.forEach((booking, eventIndex) => {
            if (booking !== undefined) {
                if (errorEventIndex === null) errorEventIndex = eventIndex;
                booking?.tickets?.forEach((ticket, ticketIndex) => {
                    if (ticket !== undefined) {
                        ticket?.guests?.forEach((guest, guestIndex) => {
                            if (guest !== undefined) {
                                const guestKey = `guest_${eventIndex}${ticketIndex}${guestIndex}`;
                                guestKeys.push(guestKey);
                            }
                        });
                    }
                });

            }
        });
        setErrorEvent(errorEventIndex)
        return guestKeys;
    };

    const scrollToFirstError = (errors) => {
        const checkErrorsData = getGuestKeys(errors)
        const fieldName = checkErrorsData?.[0]
        if (checkErrorsData) {
            if (fieldRefs.current[fieldName]) {
                fieldRefs.current[fieldName].scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                });
                fieldRefs.current[fieldName].focus();
            }
        }
    };

    return (
        <>
            {paymentLoader && <FullPageLoader text={loadingMsg} />}
            <CheckoutBreadcrumb currentStep={paymentLoader ? 3 : location.pathname === PRE_CHECKOUTPAGE ? 0 : location.pathname === CHECKOUTPAGE ? 1 : 2} />
            <Formik
                initialValues={GUEST_DATA_INITIAl_VALUE(guestDataRequirement, categorisedData, eventRequirements, preCheckoutDetails, checkForCheckoutPage, allUniqueRequiredFields, preFilledData)}
                validationSchema={guestDataValidationSchema(eventRequirements, allUniqueRequiredFields, orderTotalValue)}
                onSubmit={handleFormSubmit}
                enableReinitialize
            >
                {({ values, isSubmitting, errors, setFieldValue, setFieldError, handleSubmit }) => (
                    <Form onSubmit={handleSubmit} >
                        <div className='Events_booking_page' ref={scrolRefs}>
                            {
                                pageLoader ?
                                    <TicketPageLoader />
                                    :
                                    <div className='events_container' id='checkout_main_container' >
                                        <div className='checkout_left' >
                                            {/* {
                                    checkForCheckoutPage && */}
                                            <>
                                                {/* <PaymentGateway fieldRefs={fieldRefs} /> */}
                                                {/* <TicketDownload name={"ticket_mail"} fieldRefs={fieldRefs} /> */}
                                            </>
                                            {/* } */}
                                            <GuestDetail eventRequirements={eventRequirements} setErrorEvent={setErrorEvent} openErrorEvent={openErrorEvent} fieldRefs={fieldRefs} checkForCheckoutPage={checkForCheckoutPage} values={values} errors={errors} setFieldValue={setFieldValue} setFieldError={setFieldError}
                                                handlePreCheckout={handlePreCheckout}
                                            />
                                            <div className='checkout_booking_button_mobile' >
                                                <CheckoutBooking timeRemaining={timeRemaining} scrollToFirstError={scrollToFirstError} errors={errors} checkForCheckoutPage={checkForCheckoutPage} isBooking={isBooking} values={values} setFieldValue={setFieldValue}
                                                    isToShowSupplierShow={isToShowSupplierShow} orderTotalValue={orderTotalValue}
                                                />
                                            </div>
                                        </div>
                                        <div className='checkout_right' >
                                            <Cart fetchCartList={fetchCartList} checkoutPage orderTotalValue={orderTotalValue} setOrderTotalValue={setOrderTotalValue} markupDetails={values} />
                                            <div className='checkout_booking_button' >
                                                <CheckoutBooking timeRemaining={timeRemaining} scrollToFirstError={scrollToFirstError} errors={errors} checkForCheckoutPage={checkForCheckoutPage} isBooking={isBooking} values={values} setFieldValue={setFieldValue}
                                                    isToShowSupplierShow={isToShowSupplierShow} orderTotalValue={orderTotalValue}

                                                />
                                            </div>

                                        </div>
                                    </div>
                            }
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default CheckoutPage